import { Token } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Specificity } from "../../../specificity.js";
import { WithName } from "../../selector.js";
const { map, right, take, takeBetween } = Parser;
const { parseColon, parseIdent } = Token;
export class PseudoElementSelector extends WithName {
    constructor(name, specificity = Specificity.of(0, 0, 1)) {
        super("pseudo-element", name, specificity);
    }
    equals(value) {
        return value instanceof PseudoElementSelector && super.equals(value);
    }
    toJSON() {
        return {
            ...super.toJSON(),
        };
    }
    toString() {
        return `::${this._name}`;
    }
}
(function (PseudoElementSelector) {
    /**
     * Parses a non-functional, non-legacy pseudo-element (`::<name>`)
     */
    function parseNonLegacy(name, of) {
        return map(right(take(parseColon, 2), parseIdent(name)), of);
    }
    PseudoElementSelector.parseNonLegacy = parseNonLegacy;
    /**
     * Parses a non-functional, legacy pseudo-element (`::<name>` or `:<name>`)
     */
    function parseLegacy(name, of) {
        return map(right(takeBetween(Token.parseColon, 1, 2), Token.parseIdent(name)), of);
    }
    PseudoElementSelector.parseLegacy = parseLegacy;
})(PseudoElementSelector || (PseudoElementSelector = {}));
//# sourceMappingURL=pseudo-element.js.map